// extracted by mini-css-extract-plugin
export default {"Container":"VirtualViewButton-module__Container--uXA7r","ContainerLarge":"VirtualViewButton-module__ContainerLarge--C_h2q"};